export function referenceReplaceArgs(tokenId) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var tokenOptions = arguments.length > 2 ? arguments[2] : undefined;

  var token = function token(a, fromRef) {
    return fromRef(tokenId, args);
  };

  token.tokenOptions = tokenOptions;
  return token;
}
export function referenceForwardArgs(tokenId, tokenOptions) {
  var token = function token(args, fromRef) {
    return fromRef(tokenId, args);
  };

  token.tokenOptions = tokenOptions;
  return token;
}
//# sourceMappingURL=references.js.map